/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import DashBoardContainer from "../../../layout/dashboard-container";
import { useFormik, FormikProvider, Form } from "formik";

import {
  Alert,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import { labels } from "../../../../lang/labels";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import SelectInput from "../../../form-fields/select-input";
import DateInput from "../../../form-fields/date-picker";
import { useSelector } from "react-redux";
import FormButtons from "../buttons";
import {
  getUserZoneList,
  getCoinageList,
  getCoinageChallonNo,
  createCoinageChallan,
} from "../../../../services/coinage-challan-service";
import { challanSchema } from "../../../../utils/validation-schema";
import { useNavigate } from "react-router-dom";
import useApiState from "../../common/useApiState";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { getCurrentDate, getErrorMsg } from "../../../../utils/helpers";
import { showToastError, showToastSuccess } from "../../../common/toastHelper";

const CoinageChallan = () => {
  const navigate = useNavigate();
  const initialState = {
    zoneName: "",
    receiptDate: getCurrentDate(),
  };
  const [factors, setCoinageList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [results, setResults] = useState([]);
  const [totalSum, setTotalSum] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [challanInfo, setChallanInfo] = useState("");
  const lang = useSelector((state) => state.userDetails.lang);

  const [inputValues, setInputValues] = useState(
    Array(factors.length).fill("")
  );

  // eslint-disable-next-line no-unused-vars
  const { loading, setLoading, error, setError, success, setSuccess } =
    useApiState();

  const resetStateData = () => {
    window.location.reload();
  };

  useEffect(() => {
    const sum = results.reduce((acc, curr) => acc + (curr || 0), 0);
    setTotalSum(sum);
  }, [results]);

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: challanSchema,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError("");
        setLoading(true);
        const [coinageListRes, zoneListRes] = await Promise.all([
          getCoinageList(),
          getUserZoneList(),
        ]);

        // const factorsList = coinageListRes.map((item) => item.notetype);
        setCoinageList(coinageListRes);
        const zoneList = zoneListRes.map((record) => ({
          value: record.zonename,
          label: record.zonename,
        }));
        setZoneList(zoneList);
        // showToastSuccess();
      } catch (error) {
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs only once

  const handleInputChange = (index, e) => {
    const value = e.target.value;
    const updatedInputValues = [...inputValues];
    updatedInputValues[index] = value;
    setInputValues(updatedInputValues);
    const numericValue = parseFloat(value);
    const updatedResults = [...results];
    if (!isNaN(numericValue)) {
      updatedResults[index] =
        numericValue *
        factors.find((item) => item.mstnotesdenominationkey === index).notetype;
    } else {
      updatedResults[index] = null;
    }
    setResults(updatedResults);
  };

  useEffect(() => {
    window.localStorage.removeItem("CashChallanInput");
    const getChallanData = async () => {
      try {
        setError("");
        setLoading(true);
        const res = await getCoinageChallonNo(formik.values);
        setChallanInfo(res);
        showToastSuccess();
      } catch (error) {
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    };
    if (formik.values.zoneName && formik.values.receiptDate) {
      getChallanData();
    }
  }, [formik.values]);

  const handleSubmit = async () => {
    let lstChalanDenomination = [];
    factors.forEach((item) => {
      const countOfNotes = inputValues[item.mstnotesdenominationkey];
      const totalAmountOfNotes = results[item.mstnotesdenominationkey];
      if (countOfNotes && totalAmountOfNotes) {
        lstChalanDenomination.push({
          // mstnotesdenominationkey: item.mstnotesdenominationkey,
          notetype: item.notetype,
          notecount: parseInt(countOfNotes),
          noteamount: totalAmountOfNotes,
        });
      }
    });

    const body = {
      lstChalanDenomination,
      ...challanInfo,
    };

    try {
      setError("");
      setLoading(true);
      const response = await createCoinageChallan(body);
      showToastSuccess(
        "Chalan created successfully, you will be redirected to view chalan screen automatically after 5 seconds..."
      );
      setTimeout(() => {
        window.localStorage.setItem(
          "CashChallanInput",
          JSON.stringify(response)
        );
        navigate("/CashChallan");
        //navigate("/ViewChallan");
      }, 5000);
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = totalSum !== challanInfo.chalanAmount;

  return (
    <DashBoardContainer>
      <FormikProvider value={formik}>
        <Form>
          {success && <Alert severity="success">{success}</Alert>}
          {loading && <Loader />}
          {error && (
            <AlertMsg
              message={error}
              severity="error"
              onClose={() => {
                setError("");
              }}
            />
          )}
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.PaymentChallan[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} required />
                <FormValue
                  component={
                    <SelectInput name="zoneName" options={zoneList} required />
                  }
                />
                <FormLabel label={labels.Date[lang]} required />
                <FormValue
                  component={<DateInput name="receiptDate" disableFuture maxDate={new Date()} required />}
                />
              </GridRow>
              {challanInfo ? (
                <GridRow>
                  <FormLabel label={labels.ChallanNo[lang]} />
                  <FormValue component={challanInfo.chalanNo.toString()} />
                  <FormLabel label={labels.ReceiptAmount[lang]} />
                  <FormValue component={challanInfo.chalanAmount.toString()} />
                </GridRow>
              ) : (
                <GridRow
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  <Alert
                    severity="info"
                    sx={{
                      margin: "5px",
                      justifyContent: "center",
                    }}
                  >
                    Please select Zone and Receipt Date to Create Challan
                  </Alert>
                </GridRow>
              )}
            </Grid>
          </Paper>
          {challanInfo && (
            <>
              <GridRow>
                <TableContainer>
                  <Table
                    size="small"
                    sx={{ minWidth: 600, width: "auto", margin: "auto" }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          background: "#e6eaeb",
                          "&:last-child td, &:last-child th": { border: 1 },
                        }}
                      >
                        <TableCell align="center">
                          {labels.Rupaye[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.Naanewari[lang]}
                        </TableCell>
                        <TableCell align="center">
                          {labels.RakkamRupaye[lang]}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {factors.map((factor, index) => (
                        <TableRow key={index}>
                          <TableCell>{factor.notetype}</TableCell>
                          <TableCell>
                            <TextField
                              value={
                                inputValues[factor.mstnotesdenominationkey]  || ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  factor.mstnotesdenominationkey,
                                  e
                                )
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  padding: "0.5px 14px",
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {results[factor.mstnotesdenominationkey] !== null
                              ? results[factor.mstnotesdenominationkey]
                              : 0}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell>{labels.Total[lang]}</TableCell>
                        <TableCell>{totalSum}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={isDisabled}
                    handleSubmitButtonClick={handleSubmit}
                    resetForm={() => {
                      formik.resetForm();
                      resetStateData();
                    }}
                    submitBtnLabel="Submit"
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};

export default CoinageChallan;
